<template>
  <div class="page">
    <van-nav-bar left-text="返回" :title="$route.meta.title" @click-left="$comm.onClickLeft" v-show="$comm.titleShow()" left-arrow fixed>
      <template #left>
        <span class="iconfont iconshang comm-rotate-270"></span>
        <span class="comm-return">返回</span>
      </template>
    </van-nav-bar>
    <div class="comm-topbar-height" v-show="$comm.titleShow()"></div>

    <van-tabs @click="onClick" v-model="active1" v-show="flag">
      <van-tab title="个人用户">
      </van-tab>
      <van-tab title="单位用户">
      </van-tab>
    </van-tabs>

    <van-form @submit="onUserSubmit" :validate-trigger="$trigger" v-show="active1 == 0">
      <van-cell-group title="原用户信息">
        <van-field readonly required clickable :value="form.fuserno" label="缴费号" placeholder="请选择缴费号" :rules="[{ required: true, message: '点击选择缴费号' }]">
          <template v-if="!$route.query.readonly" #button>
            <van-button type="info" size="mini" native-type="button" @click="choiceClick()">选择</van-button>
          </template>
        </van-field>
        <van-field readonly v-model="form.foldname" label="用户名称" />
        <van-field readonly v-model="form.ffixaddr" label="用水地址" />
        <van-field v-model="form.fnetmark" rows="2" autosize label="备注信息" type="textarea" maxlength="500" placeholder="请输入备注" show-word-limit />
      </van-cell-group>

      <van-cell-group title="新产权人信息">
        <van-field required v-model="form.fname" @blur="fname" label="姓名" placeholder="姓名" :rules="[{ required: true, message: '请输入用户姓名' }]" />
        <!-- <van-field required v-model="form.faddr" label="通讯地址" placeholder="通讯地址" :rules="[{ required: true, message: '请输入通讯地址' }]" /> -->
        <van-field required v-model="form.fargueno" label="身份证号" placeholder="身份证号" :rules="[{ pattern: $patternId, message: '请输入身份证号' }]" />
        <van-field v-model="form.fpho" label="电话号码" placeholder="电话号码" />
        <van-field required v-model="form.fmoveno" label="接收短信号码" placeholder="接收短信号码" :rules="[{ pattern: $pattern, message: '请输入接收短信号码' }]" />
      </van-cell-group>

      <van-cell-group title="证件资料">
        <van-field required name="uploader" label="产权人身份证(上传正反面2张)">
          <template #input>
            <van-uploader multiple :max-count="2" v-model="cardPositiveMst" :after-read="cardPositiveAfter" @delete="cardPositiveDelete" />
          </template>
        </van-field>
        <van-field name="uploader" required label="产权证明">
          <template #input>
            <van-uploader multiple :max-count="3" v-model="propertyOwnerMst" :after-read="propertyOwnerAfter" @delete="propertyOwnerDelete" />
          </template>
        </van-field>
        <van-field name="uploader" label="其他资料">
          <template #input>
            <van-uploader multiple :max-count="3" v-model="otherMst" :after-read="otherAfter" @delete="otherDelete" />
          </template>
        </van-field>
      </van-cell-group>

      <van-cell-group title="申请人信息">
        <van-field center clearable label="申请人类别" placeholder="" readonly>
          <template #input>
            <van-radio-group v-model="fnetapplytype" direction="horizontal">
              <van-radio name="1" @click="onChanquanren">产权人
                <!-- <template #icon="props">
                                <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                            </template> -->
              </van-radio>
              <van-radio name="2" @click="onShenqingren">申请人
                <!-- <template #icon="props">
                                <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                            </template> -->
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field :required="shenqingren && active == 0" v-model="form.foper" label="姓名" placeholder="请输入姓名" v-if="shenqingren && active == 0" :rules="[{required: true, message: '请输入姓名'}]" />
        <van-field :required="shenqingren && active == 0" v-model="form.foperidno" label="身份证号" placeholder="请输入身份证号" v-if="shenqingren && active == 0" :rules="[{pattern: $patternId, message: '请输入正确身份证号'}]" />
        <van-field v-model="form.fopertel" label="电话号码" placeholder="请输入电话号码" v-if="shenqingren && active == 0" />
        <van-field required v-model="form.fopermobile" label="手机号码" placeholder="请输入手机号码" :rules="[{pattern: $pattern, message: '请输入正确手机号码'}]" />
        <van-field v-show="modify" required v-model="form.smscode" center clearable label="短信验证" placeholder="请输入短信验证" :rules="[{required: true, message: '请输入短信验证'}]">
          <template #button>
            <sms-btn :phone="form.fopermobile"></sms-btn>
          </template>
        </van-field>
      </van-cell-group>

      <yonghuxuzhi v-show="modify" @changeChecked="changeChecked" :typecode="typecode" :ftrantype="1"></yonghuxuzhi>

      <van-button v-show="modify" :disabled="!checked" block type="info" native-type="submit">
        提交
      </van-button>
    </van-form>

    <van-form @submit="onSubmit" :validate-trigger="$trigger" v-show="active1 == 1">
      <van-cell-group title="原用户信息">
        <van-field readonly clickable :value="unitForm.fuserno" label="缴费号" placeholder="请选择缴费号" :rules="[{ required: true, message: '点击选择缴费号' }]">
          <template v-if="!$route.query.readonly" #button>
            <van-button type="info" size="mini" native-type="button" @click="choiceClick()">选择</van-button>
          </template>
        </van-field>
        <van-field readonly v-model="unitForm.foldname" label="用户名称" />
        <van-field readonly v-model="unitForm.ffixaddr" label="用水地址" />
        <van-field v-model="unitForm.fnetmark" rows="2" autosize label="备注信息" type="textarea" maxlength="500" placeholder="请输入备注" show-word-limit />
      </van-cell-group>

      <van-cell-group title="新产权人信息">
        <van-field required v-model="unitForm.fname" label="单位名称" placeholder="单位名称" :rules="[{ required: true, message: '请输入单位名称' }]" />
        <!-- <van-field required v-model="unitForm.faddr" label="通讯地址" placeholder="通讯地址" :rules="[{ required: true, message: '请输入通讯地址' }]" /> -->
        <van-field v-model="unitForm.flegal" label="法人姓名" placeholder="法人姓名" />
        <van-field v-model="unitForm.fpho" label="联系电话" placeholder="联系电话" />
        <van-field required v-model="unitForm.fmoveno" label="接收短信号码" placeholder="接收短信号码" :rules="[{ pattern: $pattern, message: '请输入正确接收短信号码' }]" />
      </van-cell-group>

      <van-cell-group title="发票信息">
        <van-field readonly clickable v-model="fpayid" label="发票类型" placeholder="请选择发票类型" @click="fpayidShow = true" :required="true" :rules="[{ required: true, message: '请选择发票类型'}]">
          <template #right-icon>
            <span class="iconfont iconxuanzesanjiao"></span>
          </template>
        </van-field>
        <van-popup v-model="fpayidShow" position="bottom">
          <van-picker :default-index="unitFpayidIndex" title="发票类型" show-toolbar :columns="fpayidColumns" @cancel="fpayidShow = false" @confirm="fpayidConfirm" />
        </van-popup>
        <van-field required v-model="unitForm.ftax" label="社会信用代码" placeholder="请输入社会信用代码" :rules="[{ required: true, message: '请输入社会信用代码' }]" />
        <van-field v-model="unitForm.fbasebank" label="基本银行" placeholder="请输入基本银行" />
        <van-field v-model="unitForm.fbaseaccountno" label="基本账号" placeholder="请输入基本账号" />
        <van-field v-model="unitForm.fzzaddr" label="发票地址" placeholder="请输入发票地址" />
        <van-field v-model="unitForm.fzzpho" label="联系电话" placeholder="请输入联系电话" />
      </van-cell-group>

      <van-cell-group title="证件资料">
        <van-field required name="uploader" label="营业执照（统一社会信用代码）">
          <template #input>
            <van-uploader multiple :max-count="1" v-model="businessLicenseMst" :after-read="businessLicenseAfter" @delete="businessLicenseDelete" />
          </template>
        </van-field>
        <van-field name="uploader" required label="产权证明">
          <template #input>
            <van-uploader multiple :max-count="3" v-model="unitpropertyOwnerMst" :after-read="unitpropertyOwnerAfter" @delete="unitpropertyOwnerDelete" />
          </template>
        </van-field>
        <van-field name="uploader" label="其他资料">
          <template #input>
            <van-uploader multiple :max-count="3" v-model="unitotherMst" :after-read="unitotherAfter" @delete="unitotherDelete" />
          </template>
        </van-field>
      </van-cell-group>

      <van-cell-group title="申请人信息">
        <van-field required v-model="unitForm.foper" label="姓名" placeholder="请输入姓名" :rules="[{ required: true, message: '请输入姓名' }]" />
        <van-field required v-model="unitForm.foperidno" label="身份证号" placeholder="请输入身份证号" :rules="[{ pattern: $patternId, message: '请输入正确身份证号' }]" />
        <van-field v-model="unitForm.fopertel" label="电话号码" placeholder="请输入电话号码" />
        <van-field required v-model="unitForm.fopermobile" label="手机号码" placeholder="请输入手机号码" :rules="[{ pattern: $pattern, message: '请输入正确手机号码' }]" />
        <van-field v-show="modify" required v-model="unitForm.smscode" center clearable label="短信验证" placeholder="请输入短信验证" :rules="[{ required: true, message: '请输入短信验证' }]">
          <template #button>
            <sms-btn :phone="unitForm.fopermobile"></sms-btn>
          </template>
        </van-field>
      </van-cell-group>

      <yonghuxuzhi v-show="modify" @changeChecked="unitChangeChecked" :typecode="typecode" :ftrantype="2"></yonghuxuzhi>

      <van-button v-show="modify" :disabled="!unitChecked" block type="info" native-type="submit">
        提交
      </van-button>
    </van-form>

    <van-popup v-model="popShow" class="form-pop">
      <user-select-pop :userList="userList" :isquery="0" @onSelectClick="onSelectClick"></user-select-pop>
    </van-popup>
  </div>
</template>

<script>
import smsBtn from '@/components/smsBtn.vue'
import UserSelectPop from '@/components/UserSelectPop.vue'

export default {
  name: 'MeterTransferForm',
  components: {
    smsBtn,
    UserSelectPop
  },
  data() {
    return {
      typecode: 202,
      active: 0,
      active1: 0,
      popShow: false,
      message: '',
      radio: '1',
      // 个人用户
      form: {
        fbillno: '',
        ftrantype: 1,
        fsou: this.$comm.titleShow() ? 2 : 4,
        foldpactno: '',
        foldname: '',
        fuserno: '',
        ffixaddr: '',
        fnetmark: '',
        fname: '',
        faddr: '',
        fargueno: '',
        fpho: '',
        fmoveno: '',
        attach: [],
        fnetapplytype: '1',
        foper: '',
        foperidno: '',
        fopertel: '',
        fopermobile: '',
        smscode: ''
      },
      // 单位用户
      unitForm: {
        fbillno: '',
        ftrantype: 2,
        fsou: this.$comm.titleShow() ? 2 : 4,
        foldpactno: '',
        foldname: '',
        fuserno: '',
        ffixaddr: '',
        fnetmark: '',
        fname: '',
        faddr: '',
        flegal: '',
        fpho: '',
        fmoveno: '',
        fpayid: '',
        ftax: '',
        fbasebank: '',
        fbaseaccountno: '',
        finvoicename: '',
        fzzaddr: '',
        fzzpho: '',
        femail: '',
        attach: [],
        fnetapplytype: 2,
        foper: '',
        foperidno: '',
        fopertel: '',
        fopermobile: '',
        smscode: ''
      },
      value: '',
      showPicker: false,
      userList: JSON.parse(localStorage.getItem('userList')),
      userInfo: {},
      isNameSame: false,

      chanquanren: true,
      shenqingren: false,
      fnetapplytype: '1',
      // 个人图片资料
      cardPositive: [], // 身份证正面
      cardAnti: [], // 身份证反
      propertyOwner: [], // 产权证明
      other: [], // 个人其他材料
      cardPositiveMst: [], // 身份证正面
      cardAntiMst: [], // 身份证反
      propertyOwnerMst: [], // 产权证明
      otherMst: [], // 个人其他材料
      // 单位
      fpayid: '', // 发票类型
      fpayidShow: false, // 发票类型显示
      fpayidColumns: [], // 发票类型
      businessLicense: [], // 单位营业执照
      unitpropertyOwner: [], // 单位产权证明
      unitother: [], // 单位其他材料
      businessLicenseMst: [], // 单位营业执照
      unitpropertyOwnerMst: [], // 单位产权证明
      unitotherMst: [], // 单位其他材料
      flag: this.$route.query.busstype ? false : true,
      modify: this.$route.query.modify ? (this.$route.query.modify === '1' || this.$route.query.modify === 1 ? false : true) : true,
      unitFpayidIndex: 0,
      checked: false,
      unitChecked: false
      // fpayidIndex:0
    }
  },
  mounted() {
    this.getFpayType()
    if (!this.flag) {
      this.info()
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'BusinessProgress') {
      to.meta.isUseCache = true
    }
    next()
  },
  methods: {
    fname() {
      // 判断是否是申请人，将姓名产权人带入
      if (this.shenqingren && this.active == 0) {
        this.form.foper = this.form.fname
      }
    },
    changeChecked(checked) {
      this.checked = checked
    },
    unitChangeChecked(checked) {
      this.unitChecked = checked
    },
    // 详情
    info() {
      this.$http.post(this.$api.getBussInfo, {
        busstype: this.$route.query.busstype,
        bussno: this.$route.query.bussno
      }).then(res => {
        if (res.code === '000') {
          // 个人
          if (res.data.ftrantype === 1 || res.data.ftrantype === '1') {
            this.active1 = 0
            this.form = res.data
            if (res.data.fnetapplytype == 1) {
              this.fnetapplytype = '1'
              this.onChanquanren()
            } else {
              this.fnetapplytype = '2'
              this.onShenqingren()
            }
            let result = this.$comm.serviceAttach(res.data)
            // 个人图片资料
            this.cardPositive = result.cardPositive
            this.propertyOwner = result.propertyOwner
            this.other = result.other
            this.cardPositiveMst = result.cardPositiveMst
            this.propertyOwnerMst = result.propertyOwnerMst
            this.otherMst = result.otherMst
          } else {
            // 单位
            this.active1 = 1
            this.unitForm = res.data
            this.unitFpayidIndex = this.fpayidColumns.findIndex((profile) => profile.code === res.data.fpayid)
            if (this.unitFpayidIndex != -1) {
              this.fpayid = this.fpayidColumns[this.unitFpayidIndex].text
            }
            // 单位图片资料
            let result = this.$comm.serviceAttach(res.data)
            this.businessLicense = result.businessLicense
            this.unitpropertyOwner = result.unitpropertyOwner
            this.reply = result.reply
            this.unitother = result.unitother
            this.businessLicenseMst = result.businessLicenseMst
            this.unitpropertyOwnerMst = result.unitpropertyOwnerMst
            this.replyMst = result.replyMst
            this.unitotherMst = result.unitotherMst

          }
          this.$clear()
        } else {
          this.$toast(res.msg)
        }
      })
    },
    onGetValue(key2, value) {
      this.form[key2] = value
    },
    onChanquanren() {
      this.form.fnetapplytype = 1
      this.chanquanren = true
      this.shenqingren = false
    },
    onShenqingren() {
      this.form.foper = this.form.fname
      this.form.fnetapplytype = 2
      this.chanquanren = false
      this.shenqingren = true
    },
    onClick() {

    },
    onYonghuxuzhi() {

    },
    // 身份证正面
    cardPositiveAfter(file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileuploadbase64, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.cardPositive.push({ url: res.data })
        } else {
          this.$toast('上传失败')
        }
      })
    },
    cardPositiveDelete(file, detail) {
      this.cardPositive.splice(detail.index, 1)
    },
    // 身份证正面
    cardAntiAfter(file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileuploadbase64, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.cardAnti.push({ url: res.data })
        } else {
          this.$toast('上传失败')
        }
      })
    },
    cardAntiDelete(file, detail) {
      this.cardAnti.splice(detail.index, 1)
    },
    // 产权证明
    propertyOwnerAfter(file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileuploadbase64, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.propertyOwner.push({ url: res.data })
        } else {
          this.$toast('上传失败')
        }
      })
    },
    propertyOwnerDelete(file, detail) {
      this.propertyOwner.splice(detail.index, 1)
    },
    // 其他证明
    otherAfter(file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileuploadbase64, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.other.push({ url: res.data })
        } else {
          this.$toast('上传失败')
        }
      })
    },
    otherDelete(file, detail) {
      this.other.splice(detail.index, 1)
    },
    // 获取用户信息
    onSelectClick(user) {
      this.popShow = false
      if (this.active1 == 0) {
        this.form.fuserno = user.fuserno
        this.form.foldname = user.fname
        this.form.ffixaddr = user.ffixaddr
        this.form.faddr = user.ffixaddr
      } else {
        this.unitForm.fuserno = user.fuserno
        this.unitForm.foldname = user.fname
        this.unitForm.ffixaddr = user.ffixaddr
        this.unitForm.faddr = user.ffixaddr
      }
      // this.$comm.getUserInfo(this.form.usernoold).then(res => {
      //     this.userInfo = res
      //     this.form.addrold = res.yhdz
      //     this.form.fixaddr = res.zbwz
      // })
    },
    // 显示选择户号
    choiceClick() {
      this.popShow = true
    },
    nameChange() {
      if (this.form.uname === this.form.operator) {
        this.isNameSame = true
      } else {
        this.isNameSame = false
      }
    },
    // 用户提交
    onUserSubmit() {
      this.form.attach = []
      if (this.cardPositive.length <= 0 || this.cardPositive.length < 2) {
        this.$toast('产权人身份证正反面不能为空')
        return
      }
      this.form.attach.push({
        typeid: 1,
        url: this.cardPositive[0].url + ',' + this.cardPositive[1].url
      })
      if (this.propertyOwner.length <= 0) {
        this.$toast('产权证明不能为空')
        return
      } else {
        let url = ''
        this.propertyOwner.forEach(el => {
          if (url) {
            url = url + ',' + el.url
          } else {
            url = el.url
          }
        })
        this.form.attach.push({
          typeid: 2,
          url: url
        })
      }
      if (this.other.length > 0) {
        let url = ''
        this.other.forEach(el => {
          if (url) {
            url = url + ',' + el.url
          } else {
            url = el.url
          }
        })
        this.form.attach.push({
          typeid: 13,
          url: url
        })
      }
      this.$http.post(this.$api.personTransfer, this.form).then(res => {
        if (res.code === '000') {
          this.$router.push({
            path: '/business/success',
            query: {
              title: this.$route.meta.title,
              from: '业务办理'
            }
          })
        } else {
          this.$toast(res.msg)
        }
      })
    },
    // 发票类型
    getFpayType() {
      this.fpayidColumns = []
      this.$http.post(this.$api.getBasedata, {
        "typeid": 8,
        "parentid": 0
      }).then(res => {
        if (res.code === '000') {
          res.data.forEach(el => {
            this.fpayidColumns.push({
              text: el.fname,
              code: el.fid
            })
          })
        } else {
          this.$toast(res.msg)
        }
      })
    },
    // 发票类型选择
    fpayidConfirm(obj, index) {
      this.fpayid = obj.text
      this.unitForm.fpayid = this.fpayidColumns[index].code
      this.fpayidShow = false
    },
    // 营业执照
    businessLicenseAfter(file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileuploadbase64, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.businessLicense.push({ url: res.data })
        } else {
          this.$toast('上传失败')
        }
      })
    },
    businessLicenseDelete(file, detail) {
      this.businessLicense.splice(detail.index, 1)
    },
    // 单位产权证明
    unitpropertyOwnerAfter(file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileuploadbase64, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.unitpropertyOwner.push({ url: res.data })
        } else {
          this.$toast('上传失败')
        }
      })
    },
    unitpropertyOwnerDelete(file, detail) {
      this.unitpropertyOwner.splice(detail.index, 1)
    },
    // 单位其他证明
    unitotherAfter(file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileuploadbase64, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.unitother.push({ url: res.data })
        } else {
          this.$toast('上传失败')
        }
      })
    },
    unitotherDelete(file, detail) {
      this.unitother.splice(detail.index, 1)
    },
    onSubmit() {
      this.unitForm.attach = []
      if (this.businessLicense.length <= 0) {
        this.$toast('营业执照不能为空')
        return
      }
      this.unitForm.attach.push({
        typeid: 3,
        url: this.businessLicense[0].url
      })
      if (this.unitpropertyOwner.length <= 0) {// 单位产权证明
        this.$toast('产权证明不能为空')
        return
      } else { // 单位产权证明
        let url = ''
        this.unitpropertyOwner.forEach(el => {
          if (url) {
            url = url + ',' + el.url
          } else {
            url = el.url
          }
        })
        this.unitForm.attach.push({
          typeid: 2,
          url: url
        })
      }
      if (this.unitother.length > 0) { // 单位其他材料
        let url = ''
        this.unitother.forEach(el => {
          if (url) {
            url = url + ',' + el.url
          } else {
            url = el.url
          }
        })
        this.unitForm.attach.push({
          typeid: 13,
          url: url
        })
      }
      this.$http.post(this.$api.personTransfer, this.unitForm).then(res => {
        if (res.code === '000') {
          this.$router.push({
            path: '/business/success',
            query: {
              title: this.$route.meta.title,
              from: '业务办理'
            }
          })
        } else {
          this.$toast(res.msg)
        }
      })
    }
  },
}
</script>

<style lang="less" scoped>
.meter-transfer-form {
  /deep/ .van-radio-group.van-radio-group--horizontal {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(33, 33, 33, 1);

    .van-radio--horizontal {
      margin-right: 0;
      margin-left: 4px;

      .van-radio__label {
        margin-left: 2px;
      }
    }
  }

  .form-pop {
    width: 85%;
    height: 60%;
    border-radius: 4px;
    font-size: 12px;
  }
}
</style>